import React, { useState, useEffect } from "react";
import { Box, Grid, Item, Typography, Button, Stack } from "@mui/material";
// import SearchBar from "material-ui-search-bar";
import axios from "axios";
import { useStateValue } from "../../../StateProvider";
import SingleStockRow from "./SingleStockRow";
import { Skeleton, TextField, Input } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/system";
import { withStyles } from "@material-ui/core/styles";

const AllStocksContainer = ({ mode }) => {
  const [{ token }] = useStateValue();
  const [totalStocksToShow, setTSTS] = useState(40);
  const [disableSeeMore, SetDisableSeeMore] = useState(false);
  const [stocks, setStocks] = useState([]);
  const [visibleStocks, setVisibleStocks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    console.log("running");
    axios
      .get(`https://cloud.iexapis.com/stable/ref-data/symbols?token=${token}`)
      .then((res) => {
        // setStocks(res.data);
        let data = res.data?.filter((s) => s?.type == "cs");

        // console.log("all data", data);
        setIsLoading(false);

        setStocks(data);
      })
      .catch((err) => console.log(err));
  }, []);
  const seeMore = () => {
    const length = stocks?.length;
    // console.log("seemore", length, totalStocksToShow);
    if (length - totalStocksToShow < 98) {
      setTSTS(length - 1);
      SetDisableSeeMore(true);
    } else {
      setTSTS(totalStocksToShow + 100);
    }
  };
  useEffect(() => {
    setVisibleStocks(stocks);
  }, [stocks]);
  const changeVisibleStocks = () => {
    let value = searchText;
    console.log("value", value.toLowerCase());
    if (value?.length < 1) {
      setVisibleStocks(stocks);
    } else {
      const arr = stocks.filter((s) => {
        // console.log(s?.symbol.toLowerCase(), value.toLowerCase);
        if (
          s?.symbol.toLowerCase().includes(value.toLowerCase()) ||
          s?.name.toLowerCase().includes(value.toLowerCase())
        ) {
          return true;
        }
      });
      if (arr.length < totalStocksToShow) {
        SetDisableSeeMore(true);
      } else {
        SetDisableSeeMore(false);
      }
      console.log("visibleStocks", arr);
      setVisibleStocks(arr);
    }
  };
  useEffect(() => {
    if (searchText == "") {
      setVisibleStocks(stocks);
    }
  }, [searchText]);

  const SearchField = withStyles({
    root: {
      background: "white",
      "& label.Mui-focused": {
        color: mode == "dark" ? "#22b55a" : "#000000",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "green",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "gray",
        },
        "&:hover fieldset": {
          borderColor: "gray",
        },
        "&.Mui-focused fieldset": {
          borderColor: mode == "dark" ? "#22b55a" : "#000000",
          borderSize: "2px",
        },
      },
    },
  })(TextField);

  return (
    <Box className="all__stocks__container" sx={{ minHeight: "100%" }}>
      <Typography
        variant="h5"
        component="div"
        sx={{
          fontWeight: 600,
          fontSize: "0.8rem",
          fontFamily: "Public Sans,sans-serif",
          marginBottom: "20px",
        }}
      >
        All US STOCKS
      </Typography>
      {/* <SearchBar
        //   value={value}
        onChange={(newValue) => changeVisibleStocks(newValue)}
        onRequestSearch={() => console.log("")}
        placeholder="search all US Stocks"
        style={{
          width: "60%",
          fontSize: "0.5rem",
          marginBottom: "30px",
          height: "40px",
          backgroundColor:
            mode == "light" ? "#fff" : "rgba(223, 242, 255, 0.76)",
        }}
      /> */}
      {/* <Input
        sx={{ height: "40px", width: "300px", border: "2px solid red" }}
        disableUnderline
        startIcon={<SearchIcon />}
        defaultValue="search"
      /> */}
      <Box
        sx={{
          width: "max-content",
          margin: "30px 0 30px 0",
          border: `1px solid ${mode == "light" ? "#c0c0c0" : "rgb(0,30,60)"}`,
          borderRadius: "8px",
          backgroundColor: ` ${mode == "light" ? "#f6f6f6" : "rgb(0,30,60)"}`,
        }}
      >
        <Input
          placeholder="Search All US Stocks..."
          style={{
            width: "20vw",
            minWidth: "200px",
            color: mode == "light" ? "black" : "white",

            padding: "5px 10px",
            borderRadius: "8px",
            fontFamily: "public sans",
            fontSize: "0.8rem",

            outline: "none",
          }}
          disableUnderline
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
        ></Input>
        <IconButton
          onClick={() => changeVisibleStocks()}
          sx={{ color: mode == "light" ? "gray" : "white" }}
        >
          <SearchIcon />
        </IconButton>

        {/* <TextField
          label="Search Stocks "
          sx={{
            width: "50%",
            minWidth: "300px",
            color: "gray",
            outline: "none",
            border: "none",
          }}
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          // value={searchText}
          // onRequestSearch={() => console.log("")}
          // placeholder="search all US Stocks"
          InputProps={{
            style: {
              color: mode == "light" ? "black" : "white",
              outline: "none",
              border: "none",
            },
            endAdornment: (
              <InputAdornment>
                <IconButton
                  onClick={() => changeVisibleStocks()}
                  sx={{ color: "fontSecondaryColor.main" }}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        /> */}
      </Box>

      <Box
        bgcolor="bgPrimary.main"
        sx={{
          minHeight: "100%",
          padding: "30px 6px",
          //  border: "1px solid rgb(230, 235, 241)",
          borderRadius: "8px",
        }}
      >
        <Box className="all_stocks_table" bgcolor="bgPrimary.main">
          {isLoading ? (
            <Stack direction="column" spacing={2}>
              {new Array(8).fill("x", 0, 7).map((a, i) => (
                <Stack
                  key={i}
                  direction="row"
                  spacing={1}
                  sx={{ alignItems: "center" }}
                >
                  {/* For variant="text", adjust the height via font-size */}

                  {/* For other variants, adjust the size with `width` and `height` */}
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="rounded" width={"40%"} height={40} />
                  {/* <Skeleton variant="rounded" width={"20%"} height={40} /> */}
                  <Skeleton variant="rounded" width={"33%"} height={40} />
                  <Skeleton variant="rounded" width={"19%"} height={40} />
                </Stack>
              ))}
            </Stack>
          ) : (
            <>
              <Grid
                container
                spacing={0}
                sx={{
                  fontWeight: 500,
                  fontFamily: "Public Sans",
                  fontSize: "0.8rem",
                  borderBottom: "0.8px solid lightgray",
                  color: "fontSecondaryColor.main",
                  padding: "10px 5px",
                }}
              >
                <Grid item xs={0.6}>
                  <i></i>
                </Grid>
                <Grid item md={2.6} xs={3.6}>
                  <Box>Company</Box>
                </Grid>
                <Grid item md={1.4} xs={2}>
                  <Box></Box>
                </Grid>
                <Grid item md={1.6} xs={0}>
                  <Box
                    sx={{
                      textAlign: { xs: "left", md: "center" },
                      display: { md: "inline-block", xs: "none" },
                    }}
                  >
                    Market Cap
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box sx={{ textAlign: { xs: "left", md: "center" } }}>
                    Last 1 month
                  </Box>
                </Grid>
                <Grid item xs={1.6}>
                  <Box sx={{ textAlign: "center" }}>Price</Box>
                </Grid>
              </Grid>
              {visibleStocks?.slice(0, totalStocksToShow).map((s, i) => (
                <SingleStockRow stock={s} token={token} key={i} mode={mode} />
              ))}
              {!disableSeeMore && (
                <button
                  variant="contained"
                  // style={{
                  //   marginTop: "20px",
                  //   marginLeft: "50%",
                  //   transform: "translateX(-50%)",
                  //   backgroundColor: "rPurpleColor.main",
                  //   padding: "7px 11px",
                  //   cursor: "pointer",
                  //   border: "none",
                  //   backgroundColor: "#985ceb",
                  //   color: "white",
                  //   borderRadius: "8px",
                  // }}
                  style={{
                    marginTop: "20px",
                    marginLeft: "50%",
                    transform: "translateX(-50%)",

                    padding: "6px 15px",
                    cursor: "pointer",
                    backgroundColor: "#052728",
                    color: "white",
                    border: "1px solid #f6f6f6",
                    borderRadius: "15px",
                    fontFamily: "public sans",
                    fontSize: "0.75rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() => seeMore()}
                >
                  Load More...
                </button>
              )}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AllStocksContainer;
